import { ApiProperty } from "@nestjs/swagger";

export class FgSaleReportRequest{
    @ApiProperty()
    unitId?:number;
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    category?:string;
    @ApiProperty()
    brandId?:number;
    @ApiProperty()
    poNumber?:string;
    @ApiProperty()
    product?:number;
}